import { render, staticRenderFns } from "./PrivacyOld.vue?vue&type=template&id=4bc11f46&"
import script from "./PrivacyOld.vue?vue&type=script&lang=js&"
export * from "./PrivacyOld.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports